class grid {
  static gridWords = "zero one two three four five six seven eight nine ten eleven twelve thirteen fourteen fifteen sixteen seventeen eighteen nineteen twenty twenty-one twenty-two twenty-three twenty-four twenty-five twenty-six twenty-seven twenty-eight twenty-nine thirty thirty-one thirty-two thirty-three thirty-four thirty-five thirty-six thirty-seven thirty-eight thirty-nine forty forty-one forty-two forty-three forty-four forty-five forty-six forty-seven forty-eight forty-nine fifty fifty-one fifty-two fifty-three fifty-four fifty-five fifty-six fifty-seven fifty-eight fifty-nine fifty-one fifty-two fifty-three fifty-four fifty-five fifty-six fifty-seven fifty-eight fifty-nine sixty sixty-one sixty-two sixty-three sixty-four sixty-five sixty-six sixty-seven sixty-eight sixty-nine seventy seventy-one seventy-two seventy-three seventy-four seventy-five seventy-six seventy-seven seventy-eight seventy-nine eighty eighty-one eighty-two eighty-three eighty-four eighty-five eighty-six eighty-seven eighty-eight eighty-nine ninety ninety-one ninety-two ninety-three ninety-four ninety-five ninety-six ninety-seven ninety-eight ninety-nine one-hundred".split(
    " "
  );

  static calcPx(colNumber, totalColumns, conWidth, colGutter) {
    return (
      ((conWidth - (totalColumns - 1) * colGutter) / totalColumns) * colNumber +
      (colNumber - 1) * colGutter
    );
  }

  static numberToWord(n) {
    return this.gridWords[n];
  }

  static wordPx(word, totalColumns, conWidth, colGutter) {
    return this.calcPx(
      this.gridWords.indexOf(word),
      parseInt(totalColumns.replace(/\D+/, "")),
      parseInt(conWidth.replace(/\D+/, "")),
      parseInt(colGutter.replace(/\D+/, ""))
    );
  }

  static pxWord(px, totalColumns, conWidth, colGutter) {
    let lastWidth = 0;
    let curWidth = 0;
    let lastIndex;

    let tColumns = parseInt(totalColumns.replace(/\D+/, ""));
    let cWidth = parseInt(conWidth.replace(/\D+/, ""));
    let cGutter = parseInt(colGutter.replace(/\D+/, ""));

    for (let i = 1; (i = i + 1); i <= 100) {
      lastIndex = i;
      curWidth = this.calcPx(i, tColumns, cWidth, cGutter);
      if (px >= lastWidth && px < curWidth) {
        break;
      }
      lastWidth = curWidth;
    }

    return [this.numberToWord(lastIndex), lastWidth];
  }

  static getColWidth(colNumber, totalColumns, containerWidth, columnGutter) {
    return this.calcPx(
      colNumber,
      parseInt(totalColumns.replace(/\D+/, "")),
      parseInt(containerWidth.replace(/\D+/, "")),
      parseInt(columnGutter.replace(/\D+/, ""))
    );
  }

  static size2word(size) {
    switch (true) {
      case size < 60:
        return "one";
      case size >= 60 && size < 100:
        return "two";
      case size >= 100 && size < 150:
        return "three";
      case size >= 150 && size < 200:
        return "four";
      case size >= 200 && size < 250:
        return "five";
      case size >= 250 && size < 300:
        return "six";
      case size >= 300 && size < 350:
        return "seven";
      case size >= 350 && size < 400:
        return "eight";
      case size >= 400 && size < 450:
        return "nine";
      case size >= 450 && size < 500:
        return "ten";
      case size >= 500 && size < 550:
        return "eleven";
      case size >= 550:
        return "twelve";
    }
  }

  static word2size(word) {
    switch (true) {
      case word === "one":
        return 30;
      case word === "two":
        return 80;
      case word === "three":
        return 130;
      case word === "four":
        return 180;
      case word === "five":
        return 230;
      case word === "six":
        return 280;
      case word === "seven":
        return 330;
      case word === "eight":
        return 380;
      case word === "nine":
        return 430;
      case word === "ten":
        return 480;
      case word === "eleven":
        return 530;
      case word === "twelve":
        return 580;
    }
  }
}

export default grid;
